// Marks a document_extractions "page" row whose processing failed terminally — either
// an ingest enqueue failure (splitPagesAndEnqueue) or a Cloud Tasks last-attempt
// exhaustion (processPage / processWholeExtraction). Read by finalizeJobIfDone's rollup
// (scanExtract.ts) to tell a genuinely failed page apart from a merely unmatched one.

/** review_notes prefix marking a page whose processing failed terminally. */
export const PAGE_FAILED_NOTE_PREFIX = 'Przetwarzanie nie powiodło się';

/** Build the review_notes text for a terminally failed page. */
export function pageFailedNote(reason: string): string {
  return `${PAGE_FAILED_NOTE_PREFIX}: ${reason}`;
}

/** True when a row's review_notes marks a terminally failed page. */
export function isFailedPage(row: { review_notes?: string | null }): boolean {
  return (row.review_notes ?? '').startsWith(PAGE_FAILED_NOTE_PREFIX);
}
